import { Box, Typography } from '@mui/material'
import React from 'react'
import Section from '../components/Ui/Section'
import MainSubscripe from '../components/MainSubscripe'
import ToursListServ from '../components/ToursListServ'
import { useTranslation } from 'react-i18next'
import './AlbomServ.css'
import vid from "../assets/product.mp4"
function AlpomServ() {
  const { t } = useTranslation()
  return (
    <Box>
      {/* <Box className='bgAbout'>
        <div className="overlay"></div>
        <Typography variant="h2" sx={{ zIndex: 2 }}>{t("Products.title")}</Typography>
      </Box> */}
      <>
        <div className="header">
          <div>
            <Box className='videoBg' sx={{ display: 'flex', mt: '15px' }} >
              <video autoPlay={true} muted src={vid} loop width={'100%'}>
                Your browser does not support the video tag.
              </video>
            </Box>
          </div>
        </div>
      </>
      <Section title={t('linksPages.PhotoGallery')}>
        <ToursListServ />
      </Section>
      <Section>
        <MainSubscripe />
      </Section>
    </Box>
  )
}

export default AlpomServ